module.exports = __webpack_public_path__ + "static/media/trimex_bebagua.ce8396f3.png";